import React from "react";

export default function PublicHomeSeo() {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://marstick.com/#organization",
        name: "Marstick",
        url: "https://marstick.com/",
        logo: "https://marstick.com/apple-touch-icon.png"
      },
      {
        "@type": "WebSite",
        "@id": "https://marstick.com/#website",
        name: "Marstick",
        url: "https://marstick.com/",
        publisher: { "@id": "https://marstick.com/#organization" },
        potentialAction: {
          "@type": "SearchAction",
          target: "https://marstick.com/en/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "SoftwareApplication",
        "@id": "https://marstick.com/#premium",
        name: "Marstick Premium",
        applicationCategory: "NavigationApplication",
        operatingSystem: "Web, iOS, Android",
        image: "https://marstick.com/apple-touch-icon.png",
        brand: "Marstick",
        description: "Daily skipper briefings for safer sailing decisions, route and weather risk awareness, marina intelligence, and premium planning tools.",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "1",
          ratingCount: "1",
          reviewCount: "1"
        },
        review: {
          "@type": "Review",
          author: {
            "@type": "Organization",
            name: "Marstick Editorial Team"
          },
          reviewRating: {
            "@type": "Rating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1"
          },
          reviewBody: "Marstick Premium is designed to help skippers make safer departure decisions with personalized briefings, route risk awareness, weather intelligence, and marina planning tools."
        },
        featureList: [
          "Personalized daily skipper briefing",
          "Route and weather risk alerts",
          "Boat-specific recommendations",
          "Offline planning and exportable trip summaries"
        ],
        offers: [
          {
            "@type": "Offer",
            name: "Free",
            price: "0",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
            hasMerchantReturnPolicy: {
              "@type": "MerchantReturnPolicy",
              applicableCountry: "US",
              returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted"
            },
            shippingDetails: {
              "@type": "OfferShippingDetails",
              shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "USD" },
              shippingDestination: { "@type": "DefinedRegion", addressCountry: "US" },
              deliveryTime: {
                "@type": "ShippingDeliveryTime",
                handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 0, unitCode: "DAY" },
                transitTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 0, unitCode: "DAY" }
              }
            },
            url: "https://marstick.com/en/"
          },
          {
            "@type": "Offer",
            name: "Premium",
            price: "0",
            priceCurrency: "USD",
            availability: "https://schema.org/PreOrder",
            hasMerchantReturnPolicy: {
              "@type": "MerchantReturnPolicy",
              applicableCountry: "US",
              returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted"
            },
            shippingDetails: {
              "@type": "OfferShippingDetails",
              shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "USD" },
              shippingDestination: { "@type": "DefinedRegion", addressCountry: "US" },
              deliveryTime: {
                "@type": "ShippingDeliveryTime",
                handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 0, unitCode: "DAY" },
                transitTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 0, unitCode: "DAY" }
              }
            },
            url: "https://marstick.com/en/premium"
          }
        ]
      }
    ]
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}